export const ERROR_FETCHING_EVENTS = error => `Unable to fetch events: ${error}`
export const MISSING_PARAMETERS = param => `Missing parameter ${param}`
export const CONTRACT_ERROR = error => `Contract Error: ${error}`
export const HTTP_ERROR = error => `HTTP Error: ${error}`
export const VALIDATION_ERROR = error => `Data Validation Error: ${error}`
export const PARAMETER_ERROR = error => `Parameter error: ${error}`
